import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";

// The full results page. The search itself happens in the search popup (the
// button in the top bar, or the round button on a phone), so this page only
// shows what was searched for. It reads the words straight from the address,
// so a second search can never leave the first one's words behind.
export default function Search() {
  const [sp] = useSearchParams();
  const query = (sp.get("q") || "").trim();
  const [results, setResults] = useState([]);
  const [doneFor, setDoneFor] = useState("");   // the search the shown results belong to

  useEffect(() => {
    let alive = true;
    if (!query) { setResults([]); setDoneFor(""); return undefined; }
    api.get(`/videos?q=${encodeURIComponent(query)}&limit=60`)
      .then((r) => { if (alive) { setResults(r.data); setDoneFor(query); } })
      .catch(() => { if (alive) { setResults([]); setDoneFor(query); } });
    return () => { alive = false; };
  }, [query]);

  let note;
  if (!query) note = "Tap the search button to look for a song by title, artist, mood or genre.";
  else if (doneFor !== query) note = "Searching…";
  else if (results.length === 0) note = `No songs match “${query}”. Try fewer letters or another word.`;
  else note = `${results.length} result${results.length === 1 ? "" : "s"}`;

  return (
    <div>
      <h1 className="font-display text-3xl sm:text-5xl font-extrabold mb-2 break-words" data-testid="search-page-heading">
        {query ? <>Search results for <span className="text-cyan-300">“{query}”</span></> : "Search"}
      </h1>
      <p className="text-sm text-zinc-500 mb-6 font-mono-ui" data-testid="search-page-note">{note}</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {doneFor === query && results.map((v) => <VideoCard key={v.id} video={v} size="sm" queue={results} />)}
      </div>
    </div>
  );
}
